module.exports = __webpack_public_path__ + "img/2094c7f.jpg";